
import { InvolvedParty, InvolvedPartyDisplay } from "@/store/site-monitor/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import UserWithBadge from "./event-search/UserWithBadge.vue";

@Component({
    "components": {
        "user-with-badge": UserWithBadge
    }
})
export default class InvolvedPartiesList extends Vue {
    @Prop({ type: Array, default: () => []}) involvedParties!: InvolvedParty[];
    @Prop({ type: Boolean, default: false }) shortenRemovedParties: boolean;

    private mapParties(parties: InvolvedParty[]): InvolvedPartyDisplay[] {
        return parties.map((party, index) => ({
            ...party,
            colourIndex: this.userColourIndex(index)
        }));
    }

    private get addedParties(): InvolvedPartyDisplay[] {
        return this.mapParties((this.involvedParties ?? []).filter(party => party.added));
    }

    private get removedParties(): InvolvedPartyDisplay[] {
        return this.mapParties((this.involvedParties ?? []).filter(party => !party.added));
    }

    /**
	* badgeColours.css contains user-1 through user-10 as badge colour classes
    * This method cycles through the ten classes, wrapping back if exceeding the max
	*/
    private userColourIndex(index: number): number {
        return (index % 10) + 1;
    }
}
